import Vue from "vue";

export default {
  getLoanTypes({ commit, state }) {
    const params = {
      page: state.currentPage,
      perPage: state.perPage,
      ...(state.searchQuery != "" && { search_query: state.searchQuery }),
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/loans/settings/loantypes`, { params })
        .then(response => {
          commit("tableLoading", false);
          commit("loanTypesTotal", response.data.total);
          commit("loanTypes", response.data.results);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },

  getAllLoanTypes() {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/loans/settings/loantypes`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getLoanTypeById(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/loans/settings/loantypes/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchLoanTypeByEmployee(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/loans/settings/loantypes/employee/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  addLoanTypes(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/loans/settings/loantypes`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  editLoanTypes(_, payload) {
    const { id, formData } = payload;
    const newFormData = {
      id: Number(id),
      ...formData,
    };
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/payroll/loans/settings/loantypes/${id}`, newFormData)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeLoanApprovalSettings(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/loans/settings/approvals/delete`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeLoanType(_, ids) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/payroll/loans/settings/loantypes/delete`, {
          data: { loan_type_ids: ids },
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addLoanCaps(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/loans/settings/loancaps`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchLoanCaps({ commit, state }, payload) {
    const params = {
      page: state.loanCapsCurrentPage,
      perPage: state.loanCapsPerPage,
      ...(state.searchQuery != "" && {
        searchByStationOrGrade: state.searchQuery,
      }),
      model_type: payload || state.modelType,
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/loans/settings/loancaps`, { params })
        .then(response => {
          commit("loanCaps", response.data.results);
          commit("loanCapsTotal", response.data.total);
          commit("tableLoading", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },
  handleSizeChange({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    dispatch("getLoanTypes");
  },

  handleCurrentChange({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getLoanTypes");
  },
  handleLoanCapsSizeChange({ commit, dispatch }, page) {
    commit("loanCapsPerPage", page);
    commit("loanCapsCurrentPage", 1);
    dispatch("fetchLoanCaps");
  },
  handleLoanCapsCurrentChange({ commit, dispatch }, page) {
    commit("loanCapsCurrentPage", page);
    dispatch("fetchLoanCaps");
  },

  fetchLoanApprovals({ commit, state }) {
    const params = {
      page: state.loanApprovalsCurrentPage,
      perPage: state.loanApprovalsPerPage,
      ...(state.searchQuery != "" && {
        search_query: state.searchQuery,
      }),
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/loans/settings/approvals`, { params })
        .then(response => {
          commit("tableLoading", false);
          commit("loanApprovals", response.data.results);
          commit("loanApprovalsTotal", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },

  addLoanApprovals(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/loans/settings/approvals`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  editLoanApprovals(_, payload) {
    const { id } = payload;
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/payroll/loans/settings/approvals/${id}`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getLoanApprovalsById(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/loans/settings/approvals/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  handleLoanApprovalsSizeChange({ commit, dispatch }, page) {
    commit("loanApprovalsPerPage", page);
    commit("loanApprovalsCurrentPage", 1);
    dispatch("fetchLoanApprovals");
  },
  handleLoanApprovalsCurrentChange({ commit, dispatch }, page) {
    commit("loanApprovalsCurrentPage", page);
    dispatch("fetchLoanApprovals");
  },

  fetchLoanRequests({ commit, state }, params2) {
    const params = {
      page: state.loanRequestsCurrentPage,
      perPage: state.loanRequestsPerPage,
      ...(params2.loan_type_id != "undefined" && {
        loan_type_id: params2.loan_type_id,
      }),
      ...(params2.start_date != "undefined" && {
        start_date: params2.start_date,
      }),
      ...(params2.end_date != "undefined" && { end_date: params2.end_date }),
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/loans/requests`, { params })
        .then(response => {
          commit("tableLoading", false);
          commit("loanRequests", response.data.results);
          commit("loanRequestsTotal", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },

  fetchLoanRequestById(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/loans/requests/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  createLoanRequest(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/loans/requests`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  editLoanRequest(_, payload) {
    const { id } = payload;
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/payroll/loans/requests/${id}`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  deleteLoanRequests(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/loans/requests/delete`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  handleLoanRequestsSizeChange({ commit, dispatch }, page) {
    commit("loanRequestsPerPage", page);
    commit("loanRequestsCurrentPage", 1);
    dispatch("fetchLoanRequests", {});
  },
  handleLoanRequestsCurrentChange({ commit, dispatch }, page) {
    commit("loanRequestsCurrentPage", page);
    dispatch("fetchLoanRequests", {});
  },

  fetchLoanRequestsApproval({ commit, state }, params2) {
    const params = {
      page: state.loanRequestsApprovalCurrentPage,
      perPage: state.loanRequestsApprovalPerPage,
      ...(params2.loan_type_id != "undefined" && {
        loan_type_id: params2.loan_type_id,
      }),
      ...(params2.start_date != "undefined" && {
        start_date: params2.start_date,
      }),
      ...(params2.end_date != "undefined" && { end_date: params2.end_date }),
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/loans/requests/approvals`, { params })
        .then(response => {
          commit("tableLoading", false);
          commit("loanRequestsApproval", response.data.results);
          commit("loanRequestsApprovalTotal", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },

  approveLoanRequests(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/loans/requests/approve`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  rejectLoanRequests(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/loans/requests/reject`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  handleLoanRequestsApprovalSizeChange({ commit, dispatch }, page) {
    commit("loanRequestsApprovalPerPage", page);
    commit("loanRequestsApprovalCurrentPage", 1);
    dispatch("fetchLoanRequestsApproval", {});
  },
  handleLoanRequestsApprovalCurrentChange({ commit, dispatch }, page) {
    commit("loanRequestsApprovalCurrentPage", page);
    dispatch("fetchLoanRequestsApproval", {});
  },

  fetchLoanDisbursements({ commit, state }, params2) {
    const params = {
      page: state.loanDisbursementsCurrentPage,
      perPage: state.loanDisbursementsPerPage,
      ...(params2.loan_type_id != "undefined" && {
        loan_type_id: params2.loan_type_id,
      }),
      ...(params2.start_date != "undefined" && {
        start_date: params2.start_date,
      }),
      ...(params2.end_date != "undefined" && { end_date: params2.end_date }),
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/loans/disbursements`, { params })
        .then(response => {
          commit("tableLoading", false);
          commit("loanDisbursements", response.data.results);
          commit("loanDisbursementsTotal", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },

  createLoanDisbursement(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/loans/disbursements`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  handleLoanDisbursementsSizeChange({ commit, dispatch }, page) {
    commit("loanDisbursementsPerPage", page);
    commit("loanDisbursementsCurrentPage", 1);
    dispatch("fetchLoanDisbursements", {});
  },

  handleLoanDisbursementsCurrentChange({ commit, dispatch }, page) {
    commit("loanDisbursementsCurrentPage", page);
    dispatch("fetchLoanDisbursements", {});
  },
  getLoanNotFullyDisbursedForEmployee(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(
          `payroll/loans/requests/get-loan-not-fully-disbursed?employee_id=${id}`
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getLoanNotFullyRefundedForEmployee(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(
          `payroll/loans/requests/get-loan-not-fully-refunded?employee_id=${id}`
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  deleteLoanDisbursements(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/payroll/loans/disbursements/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchLoanRefunds({ commit, state }, params2) {
    const params = {
      page: state.loanRefundsCurrentPage,
      perPage: state.loanRefundsPerPage,
      ...(params2.loan_type_id != "undefined" && {
        loan_type_id: params2.loan_type_id,
      }),
      ...(params2.start_date != "undefined" && {
        start_date: params2.start_date,
      }),
      ...(params2.end_date != "undefined" && { end_date: params2.end_date }),
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/loans/refund`, { params })
        .then(response => {
          commit("tableLoading", false);
          commit("loanRefunds", response.data.results);
          commit("loanRefundsTotal", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },

  createLoanRefund(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/loans/refund`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  handleLoanRefundsSizeChange({ commit, dispatch }, page) {
    commit("loanRefundsPerPage", page);
    commit("loanRefundsCurrentPage", 1);
    dispatch("fetchLoanRefunds", {});
  },

  handleLoanRefundsCurrentChange({ commit, dispatch }, page) {
    commit("loanRefundsCurrentPage", page);
    dispatch("fetchLoanRefunds", {});
  },

  deleteLoanRefunds(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/payroll/loans/refund/[${id}]`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  editLoanRefund(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/payroll/loans/refund`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchLoanRefundById(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/loans/refund/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  searchLoanRequests({ commit }, searchQuery) {
    return new Promise((resolve, reject) => {
      if (searchQuery === undefined || searchQuery === "") {
        return [];
      }

      const params = {
        ...(searchQuery != "" && { search_query: searchQuery }),
      };

      Vue.$http
        .get("/payroll/loans/requests/by-employee-loan-type", { params })
        .then(response => {
          commit("loanRequests", response.data);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
